/** Reads the X-Pagination header the list endpoints return, or null when it is missing or malformed. */
export function readPagination(response) {
  const raw = response?.headers?.["x-pagination"];
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

/**
 * Task endpoints answer with a `Result` envelope ({ isSuccess, error, value }) and some of them wrap a second
 * envelope inside the first, so a failure can arrive with an HTTP 200. Every envelope layer is peeled off and the
 * first failure found is reported next to the payload.
 */
export function unwrapResult(body) {
  let current = body;
  let failure = null;

  while (current && typeof current === "object" && typeof current.isSuccess === "boolean") {
    if (current.isSuccess === false && !failure) {
      failure = current.error ?? { message: "Something went wrong. Please try again later." };
    }
    current = current.value;
  }

  return { value: current, failure };
}
